import { proxyBE } from "./common";

export const segreteriaIULService = {
  loadLessonLiveSchedule(courseId, classId) {
    return proxyBE.get(
      `segreteria-iul/lessonLiveSchedule/${courseId}/${classId}`
    );
  },

  loadLessonOnSiteSchedule(courseId, classId) {
    return proxyBE.get(
      `segreteria-iul/lessonOnSiteSchedule/${courseId}/${classId}`
    );
  },

  loadLessonTrainingSchedule(courseId, classId) {
    return proxyBE.get(
      `segreteria-iul/lessonTrainingSchedule/${courseId}/${classId}`
    );
  },

  loadLessonStudentSchedule(fiscalCode) {
    return proxyBE.get(`segreteria-iul/studentLessonSchedule/${fiscalCode}`);
  },
};
